import React , { useState } from 'react';
import {
  Button, SimpleForm, DateInput, AutocompleteArrayInput, SelectArrayInput, SelectInput, ReferenceArrayInput, Toolbar, useNotify,
  TextField, Datagrid, Edit, Create, List, DateField, Filter, TextInput, BooleanInput, SaveButton, required, FormDataConsumer
} from 'react-admin';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import SendReportIcon from '@material-ui/icons/Email';
import CircularProgress from '@material-ui/core/CircularProgress'
import DataTable from 'react-data-table-component';
import { fetchUtils, usePermissions } from 'react-admin';
import { AlertComponent } from './components/alerts.js';
import { NoBidChartComponent } from './components/chart.js';
import { DisclaimerComponent } from './components/disclaimer.js';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const fetch = fetchUtils.fetchJson;


const BASE_URL = window.nobid_endpoint+'/segmentreports_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

// https://github.com/jbetancur/react-data-table-component/blob/master/stories/DataTable/Basic/ExportCSV.stories.js
function convertArrayOfObjectsToCSV(array) {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  let keys = Object.keys(array[0]);
  keys = keys.filter(key => (key!=='code' && key!=='adx_ad_requests' && key!=='id'));

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (key==='code' || key==='adx_ad_requests' || key==='id') return;
      if (ctr > 0) result += columnDelimiter;

      result += item[key];
      // eslint-disable-next-line no-plusplus
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

function downloadCSV(array) {
  array.forEach((row, i) => {
    delete array[i].id
    delete array[i].code
  })
  dataSupport.exportData(array)
}

const choicesInterval = [
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' },
  { id: 'year', name: 'Yearly' }
];
const choicesShowAdmin = [
  { id: 'date', name: 'Date' },
  { id: 'segment', name: 'Segment' },
  { id: 'publisher', name: 'Publisher' },
  { id: 'site', name: 'Site' },
  { id: 'tldomain', name: 'Domain/App' },
  { id: 'country', name: 'Country' },
  { id: 'device', name: 'Device' },
  { id: 'page_url', name: 'Page URL' }
]

const countryChoices = [
  { id: 'US', name: 'US' },
  { id: 'ROW', name: 'ROW' }
]

const choicesShow = (permissions) => {
  if (!permissions) return []
  return choicesShowAdmin;
}

const choicesDevices = [
  { id: 'COMPUTER', name: 'Desktop' },
  { id: 'MOBILE', name: 'Mobile' },
  { id: 'TABLET', name: 'Tablet' },
  { id: 'DIGITAL MEDIA RECEIVER', name: 'Digital media receiver' }
]

const BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true, alwaysOn: true, cell: row => row.date },
  { name: 'Segment ID', selector: 'segment_id', sortable: true },
  { name: 'Segment', selector: 'segment_name', sortable: true },
  { name: 'Publisher', selector: 'publisher_name', sortable: true },
  { name: 'Site', selector: 'site_name', sortable: true },
  { name: 'Site ID', selector: 'site_id', sortable: true },
  { name: 'Domain/App', selector: 'tldomain', sortable: true },
  { name: 'Page URL', selector: 'page_url', sortable: true, width: '50%' },
  { name: 'Country', selector: 'country', sortable: true },
  { name: 'Device', selector: 'device', sortable: true },
  { name: 'Ad Requests', selector: 'ad_requests', alwaysOn: true, sortable: true, cell: row => <span>{ utils.formatLong(row.ad_requests) }</span> },
  { name: 'Impressions', selector: 'impressions', alwaysOn: true, sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span> },
  { name: '$Gross Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span> },
  { name: '$Avg CPM', selector: 'avg_cpm', sortable: true, cell: row => <span>{ utils.formatDouble(row.avg_cpm) }</span> }
];

const defaultColumnSelectors = ['ad_requests', 'impressions', 'revenue', 'avg_cpm'];

const chartMetricsChoicesAdmin = [
	{id:'ad_requests', name: 'Ad Requests' },
  {id:'impressions', name:'Impressions'},
  {id:'revenue', name:'$Gross Revenue'}
];

let chartMetricsChoices = () => {
  return chartMetricsChoicesAdmin;
};
const chartFormatChoices = [
	{id:'line', name:'Lines'},
	{id:'spline', name:'Smoothed'},
	{id:'column', name:'Bars'},
	{id:'area', name:'Area'},
];

const dateRangeChoices = [
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];

let columns = [];

const SendScheduledReportButton = (props) => {
  let [disabled, setDisabled] = useState();
  let [label, setLabel] = useState('Save & Send Report');
  let [icon, setIcon] = useState(<SendReportIcon />);
  const notify = useNotify();
  const handleClick = () => {
    if (formData.scheduler && formData.scheduler.emails) {
      setDisabled(true);
      setLabel('Processing...');
      setIcon(<CircularProgress size={20} />);
      setTimeout(() => {
        setDisabled(false);
        setLabel('Save & Send Report');
        setIcon(<SendReportIcon />);
      }, 7500);
      const url = window.nobid_endpoint + '/segmenteports_send';
      const requestOptions = {headers: new Headers()}
      requestOptions.headers.set('accept', 'application/json')
      const token = localStorage.getItem('token');
      requestOptions.headers.set('Authorization', `Bearer ${token}`);
      requestOptions.method =  'POST';
      requestOptions.body = JSON.stringify(formData)
      fetch(url, requestOptions).then(({ json }) => {
        notify(json.message, { type: 'info' });
      });
    } else {
      notify('No emails to send to, please add a emails to the scheduler', { type: 'error' });
    }
  }
  return <Button label={label} disabled={disabled} onClick={handleClick} props={props} variant="contained"
    style={{marginRight: '25px', padding: '7px', width: '230px'}} color="primary" startIcon={icon}/>;
};

class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    super(props);
    this.parent = props.parent;
  }

  updateChart = function(options) {
	  if (!this) return;
	  this.parent.refs.nobidChart.refreshChart(this.parent.state.data, chartMetricsChoices(), chartFormatChoices, options);
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date) r.date = new Date(r.date).toDateString();
      }

      const showList = formData.show || [];
      const columnSelectors = defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`]));

      that.parent.setState({
        data: json,
        saved_data:json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false});
      // that.updateChart({metric: formData.metric, format: formData.format});
    }

    formData.show = formData.show || [];
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}` +
      `${utils.formDataFieldsQueryStringFormat(
          formData,
          ['interval', 'date_range', 'start_date', 'end_date', 'publisher_id', 'site_id', 'segment_id',
            'device', 'country']
      )}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.props.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.props.loading}/>
        {/* { this.parent.props.formType === 'edit' &&
          <SendScheduledReportButton props={this.props}/> } */}
        
      </Toolbar>
    )
  }
}

const SegmentReportTitle = ({ record }) => {
  return <span>Segments Report {record ? `"${record.report_name}"` : ''}</span>;
};

const SegmentReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);

export const SegmentReportsList = ({ permissions, ...props }) => (
  <List {...props} title="Segments Reports" perPage={25} bulkActionButtons={false} filters={<SegmentReportFilters />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="report_name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);

let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

class SegmentReportComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  updateChart = function(options) {
	  this.refs.nobidChart.refreshChart(this.state.data, chartMetricsChoices(), chartFormatChoices, options);
  }

  handleChartMetricChanged = (value) => {
	  this.updateChart({metric: value.target.value});
  }

  handleChartFormatChanged = (value) => {
	  this.updateChart({format: value.target.value});
  }

  render() {
    const { loading, data, total, dateRange } = this.state;
    const { permissions } = this.props;
    return (
      <div>
        <AlertComponent />
        <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: 'inherit', borderRadius: '5px' }} {...this.props}>
          <TextInput source="report_name" label="Report Name" style={{ width: '400px' }} validate={required()} />
          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
            <FormDataConsumer>
              {({ formData }) => setFormData(formData) }
            </FormDataConsumer>
            <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' 
              disabled={loading}/>
            <div>
              <SelectInput label="Date Range" source="date_range"
                onChange={value => this.setState({ dateRange: value.target.value })}
                choices={dateRangeChoices}
                defaultValue="8"
                disabled={loading} />
              <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
                <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
              </div>
					  </div>
            <SelectArrayInput label="Show" 
              source="show" 
              choices={choicesShow(permissions)}
              style={{ width: '400px', flexGrow: 1}}
              defaultValue={['segment']}
              disabled={loading} />
          </div>
            
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
            {permissions &&
                <div style={{flex: 1}}>
                  <ReferenceArrayInput 
                    source="segment_id" 
                    label="Segments" 
                    reference="segments"
                    basePath='segments'
                    perPage={15} 
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    allowEmpty
                    disabled={loading}>
                    <AutocompleteArrayInput disabled={loading} label="Segments" 
                      optionText="name"
                      optionValue="code"
                      fullWidth/>
                  </ReferenceArrayInput>
                </div>
              }

              <div style={{flex: 1}}>
                <ReferenceArrayInput 
                  source="publisher_id" 
                  label="Publisher" 
                  reference="publishers"
                  basePath="publishers"
                  perPage={15} 
                  sort={{ field: 'name', order: 'ASC' }}
                  filterToQuery={searchText => ({ search_name: searchText })}
                  allowEmpty
                  disabled={loading}>
                  <AutocompleteArrayInput disabled={loading}
                    label="Publishers"
                    optionText="name"
                    optionValue="code"
                    fullWidth/>
                </ReferenceArrayInput>
              </div>

              {permissions &&
                <div style={{flex: 1}}>
                  <ReferenceArrayInput 
                    source="site_id" 
                    label="Site" 
                    reference="sites"
                    basePath='sites'
                    perPage={15} 
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    allowEmpty
                    disabled={loading}>
                    <AutocompleteArrayInput disabled={loading} label="Sites" 
                      optionText={x => x.adunit_path ? `${x.adunit_path}` : ''}
                      optionValue="code"
                      fullWidth/>
                  </ReferenceArrayInput>
                </div>
              }
            </div>
        
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} >
              <div style={{flex: 1}}>
                <SelectArrayInput label="Devices" 
                  source="device" 
                  choices={choicesDevices} 
                  disabled={loading}
                  fullWidth />
              </div>

              <div style={{flex: 1}}>
                <SelectArrayInput label="Countries"
                  source="country"
                  choices={countryChoices}
                  disabled={loading}
                  fullWidth/>
              </div>
            </div>
            {/* <div style={{ width: '100%', overflow: 'hidden'}} >
              <div style={{ float:'right' }}>
              <SelectInput label="Chart Format" 
                source='format' 
                choices={chartFormatChoices}
                defaultValue={'line'}
                onChange={this.handleChartFormatChanged} 
                disabled={loading}
                style={{ paddingRight: '5px' }}
              />
              <SelectInput label="Show in Chart" 
                source='metric' 
                choices={chartMetricsChoices()}
                defaultValue={'ad_requests'}
                onChange={this.handleChartMetricChanged} 
                disabled={loading}
              />
              </div>
            </div> */}
          {/* <ReportScheduler/> */}
        </SimpleForm>
        <div style={{ height: '5px' }} />
        {/* <NoBidChartComponent ref="nobidChart" /> */}
        <div style={{ height: '5px' }} />
        <DataTable
          title="Segment Report"
          theme={window.nobid_table_theme()}
          columns={this.state.columns}
          data={data}
          progressPending={loading}
          pagination
          fixedHeader
          paginationPerPage={30}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          dense
          highlightOnHover
          subHeader={!loading}
          subHeaderComponent={
            (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input type="text" id='search_box' label="Search" 
                variant="outlined" 
                style={{ margin: '5px' }} 
                onChange={(target) => this.filterData()}/>
                <CloudDownload 
                label="Export"
                style={{ margin: '5px' }} 
                color="action" 
                onClick={() => downloadCSV(this.state.data)}
                />
              </div>
            )
          }
        />
        <DisclaimerComponent />
      </div>
    )
  }
};

export const SegmentReportEdit = (props) => (
  <Edit title={<SegmentReportTitle />}  {...props}>
    <SegmentReportComponent formType="edit" permissions={props.permissions} {...props} />
  </Edit>
);

export const SegmentReportCreate = (props) => (
  <Create title="Create Segment Report" {...props}>
    <SegmentReportComponent formType="create" permissions={props.permissions} {...props} />
  </Create>
);
